module.exports = __webpack_public_path__ + "img/download.c15675ef.png";